var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 7.875H10.125V5.625C10.125 5.32663 10.0065 5.04048 9.7955 4.8295C9.58452 4.61853 9.29837 4.5 9 4.5C8.70163 4.5 8.41548 4.61853 8.2045 4.8295C7.99353 5.04048 7.875 5.32663 7.875 5.625V7.875H5.625C5.32663 7.875 5.04048 7.99353 4.8295 8.2045C4.61853 8.41548 4.5 8.70163 4.5 9C4.5 9.29837 4.61853 9.58452 4.8295 9.7955C5.04048 10.0065 5.32663 10.125 5.625 10.125H7.875V12.375C7.875 12.6734 7.99353 12.9595 8.2045 13.1705C8.41548 13.3815 8.70163 13.5 9 13.5C9.29837 13.5 9.58452 13.3815 9.7955 13.1705C10.0065 12.9595 10.125 12.6734 10.125 12.375V10.125H12.375C12.6734 10.125 12.9595 10.0065 13.1705 9.7955C13.3815 9.58452 13.5 9.29837 13.5 9C13.5 8.70163 13.3815 8.41548 13.1705 8.2045C12.9595 7.99353 12.6734 7.875 12.375 7.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9975 6.61383 17.0484 4.32612 15.3612 2.63885C13.6739 0.951569 11.3862 0.00254118 9 0ZM9 15.75C7.66498 15.75 6.35994 15.3541 5.2499 14.6124C4.13987 13.8707 3.27471 12.8165 2.76382 11.5831C2.25293 10.3497 2.11925 8.99251 2.3797 7.68314C2.64015 6.37377 3.28303 5.17103 4.22703 4.22703C5.17104 3.28302 6.37377 2.64015 7.68314 2.3797C8.99252 2.11925 10.3497 2.25292 11.5831 2.76381C12.8165 3.2747 13.8707 4.13987 14.6124 5.2499C15.3541 6.35993 15.75 7.66498 15.75 9C15.7481 10.7896 15.0363 12.5054 13.7708 13.7708C12.5054 15.0363 10.7896 15.7481 9 15.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.65a76a14cc74a3236f95778e1ec60c78.svg";
export { ForwardRef as ReactComponent };